module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.program.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.program.start_date)) + " - " + _vm._s(_vm.dateformat(_vm.program.end_date)) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-tab', [_vm._v("Exercises")]), _vm._v(" "), _c('v-tab', [_vm._v("Progress")]), _vm._v(" "), _c('v-tab', [_vm._v("Messages")]), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "label": "Track adherence",
      "readonly": ""
    },
    model: {
      value: (_vm.program.track_adherence),
      callback: function($$v) {
        _vm.$set(_vm.program, "track_adherence", $$v)
      },
      expression: "program.track_adherence"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "label": "Track pain levels",
      "readonly": ""
    },
    model: {
      value: (_vm.program.track_pain_levels),
      callback: function($$v) {
        _vm.$set(_vm.program, "track_pain_levels", $$v)
      },
      expression: "program.track_pain_levels"
    }
  }), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Access code sent:")]), _vm._v(" " + _vm._s(_vm.dateformat(_vm.program.access_code_sent_date)) + " via " + _vm._s(_vm.program.access_code_sent_via)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Last accessed:")]), _vm._v(" " + _vm._s(_vm.dateformat(_vm.program.last_access_date)) + "\n          ")])], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Access details")]), _vm._v(" "), _c('v-card-text', [(_vm.programUrl) ? _c('copy-text-field', {
    attrs: {
      "label": "Share this url with you client so that they can access Physitrack",
      "text-to-copy": _vm.programUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Access code:")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(_vm.program.access_code))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date of birth:")]), _vm._v(" " + _vm._s(_vm.dateOfBirth) + "\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [(_vm.requests.exercises.loading) ? [(!_vm.exercises || _vm.exercises.length === 0) ? _c('tombstone') : _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 1
    }
  })] : _vm._e(), _vm._v(" "), _c('v-list', [_vm._l((_vm.exercises), function(exercise, index) {
    return [_c('exercise-list-item', {
      key: ("ex-" + (exercise.id) + "-" + index),
      model: {
        value: (_vm.exercises[index]),
        callback: function($$v) {
          _vm.$set(_vm.exercises, index, $$v)
        },
        expression: "exercises[index]"
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-exercises-" + (exercise.id) + "-" + index)
    })]
  })], 2)], 2), _vm._v(" "), _c('v-tab-item', [(_vm.requests.adherence.loading) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.progress || !_vm.progress.days) ? _c('tombstone') : _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 1
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "grey lighten-4",
    attrs: {
      "xs4": ""
    }
  }, [(_vm.progress && _vm.progress.days) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.progress.days), function(day) {
    return [_c('v-list-tile', {
      key: day.date,
      on: {
        "click": function($event) {
          _vm.selectedDate = day.date
        }
      }
    }, [_c('v-list-tile-avatar', [_c('adherence-progress', {
      model: {
        value: (day.avg_day_adherence),
        callback: function($$v) {
          _vm.$set(day, "avg_day_adherence", $$v)
        },
        expression: "day.avg_day_adherence"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.dateformat(day.date)) + "\n                    ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-progress-linear', {
      key: ("div-" + (day.date)),
      staticClass: "ma-0",
      attrs: {
        "value": day.avg_day_adherence,
        "height": "1"
      }
    })]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [(_vm.progressDetail) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.dateformat(_vm.selectedDate)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('adherence-progress', {
    model: {
      value: (_vm.progressDetail.avg_day_adherence),
      callback: function($$v) {
        _vm.$set(_vm.progressDetail, "avg_day_adherence", $$v)
      },
      expression: "progressDetail.avg_day_adherence"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.progressDetail && _vm.progressDetail.exercises) ? [_c('v-list', {
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [_vm._l((_vm.progressDetail.exercises), function(exercise, index) {
    return [_c('exercise-list-item', {
      key: ("prog-" + (exercise.id) + "-" + index),
      model: {
        value: (_vm.progressDetail.exercises[index]),
        callback: function($$v) {
          _vm.$set(_vm.progressDetail.exercises, index, $$v)
        },
        expression: "progressDetail.exercises[index]"
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (exercise.id) + "-" + index)
    })]
  }), _vm._v(" "), (_vm.progressDetail.exercises.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                    No exercises completed\n                  ")])], 1)], 1) : _vm._e()], 2)] : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-tab-item', [(_vm.requests.messages.loading) ? [(!_vm.messages || _vm.messages.length === 0) ? _c('tombstone') : _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 1
    }
  })] : _vm._e(), _vm._v(" "), _c('messages', {
    attrs: {
      "physitrack-client-id": _vm.physitrackClientId,
      "messages": _vm.messages
    },
    on: {
      "new": _vm.getMessages
    }
  })], 2)], 1)], 1), _vm._v(" "), (_vm.requests.send.status === 409) ? _c('v-alert', {
    attrs: {
      "disabled": "",
      "outlined": "",
      "outline": "",
      "small": "",
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.requests.send.errors.errors) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.requests.send.status !== 200) ? _c('v-btn', {
    attrs: {
      "small": "",
      "disabled": !_vm.program.access_code,
      "loading": _vm.requests.send.loading
    },
    on: {
      "click": function($event) {
        return _vm.send(_vm.program.access_code)
      }
    }
  }, [_vm._v("\n      Send "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("send")])], 1) : _vm._e(), _vm._v(" "), (_vm.requests.send.status === 200) ? _c('v-btn', {
    attrs: {
      "disabled": "",
      "outlined": "",
      "outline": "",
      "small": "",
      "color": "success"
    }
  }, [_vm._v("Sent")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "loading": _vm.downloading
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.program.access_code)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("cloud_download")]), _vm._v(" Download PDF\n    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "href": _vm.program.sso_url,
      "target": "_blank"
    }
  }, [_vm._v("\n      Open Program "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5061202","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/Program.vue
// module id = 1521
// module chunks = 9